import { commonHeader, kintoneAdminEndpoints } from "~/config/apiConfig";

export type KintoneAdminInfo = {
  is_registered: boolean;
  id?: string;
  subdomain?: string;
  login_id?: string;
};

export class KintoneAdminApi {
  private getRequestInfo(method: string, requestBody?: object): RequestInit {
    return {
      method: method,
      headers: commonHeader,
      credentials: "include",
      keepalive: true,
      ...(requestBody && {
        body: JSON.stringify(requestBody),
      }),
    };
  }

  async getKintoneAdmin(organizationId: string, projectId: string): Promise<KintoneAdminInfo> {
    const endpoint = kintoneAdminEndpoints.getKintoneAdmin(organizationId, projectId);
    const requestInfo = this.getRequestInfo("GET");

    try {
      const response = await fetch(endpoint, requestInfo);
      if (response.ok) {
        return await response.json();
      }
      return { is_registered: false };
    } catch (error) {
      console.error("Error fetching kintone admin:", error);
      return { is_registered: false };
    }
  }

  async createKintoneAdmin(
    organizationId: string,
    projectId: string,
    body: { subdomain: string; login_id: string; password: string },
  ): Promise<{ success: boolean; error?: string }> {
    const endpoint = kintoneAdminEndpoints.createKintoneAdmin(organizationId, projectId);
    const requestInfo = this.getRequestInfo("POST", body);

    try {
      const response = await fetch(endpoint, requestInfo);
      if (response.ok) {
        return { success: true };
      }
      const errorData = await response.json();
      return { success: false, error: errorData.message || "登録に失敗しました" };
    } catch (error) {
      console.error("Error creating kintone admin:", error);
      return { success: false, error: "通信エラーが発生しました" };
    }
  }

  async deleteKintoneAdmin(
    organizationId: string,
    projectId: string,
    adminId: string,
  ): Promise<boolean> {
    const endpoint = kintoneAdminEndpoints.deleteKintoneAdmin(organizationId, projectId, adminId);
    const requestInfo = this.getRequestInfo("DELETE");

    try {
      const response = await fetch(endpoint, requestInfo);
      return response.ok;
    } catch (error) {
      console.error("Error deleting kintone admin:", error);
      return false;
    }
  }
}
